import React from "react";
import { ArrowLeft, Palette } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "@/context/AuthContext";
import PlatformProfileMenu from "@/components/PlatformProfileMenu";

export default function BrandStudioShell({ title = "Brand Studio", children }) {
  const nav = useNavigate();
  const { user, logout } = useAuth();

  return <div className="min-h-screen bg-[#F7F1E7]" data-testid="brand-studio-shell">
    <header className="border-b border-[#E7DAC5] bg-[#FFFDF8]">
      <div className="mx-auto flex min-h-16 w-full max-w-[1360px] items-center gap-3 px-4 md:px-8">
        <button type="button" onClick={() => nav("/hall")}
                className="inline-flex min-h-11 shrink-0 items-center gap-1.5 rounded-xl px-3 text-[12.5px] text-[#4A3728] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C7A574]/50"
                style={{ boxShadow: "inset 0 0 0 1px #E1D2BB" }}
                data-testid="brand-studio-back-to-hall">
          <ArrowLeft size={14} /> <span className="hidden sm:inline">В Anokina Studio</span>
        </button>
        <div className="flex min-w-0 flex-1 items-center gap-2.5">
          <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-[#F1E5D1] text-[#7A6247]" aria-hidden="true">
            <Palette size={16} />
          </span>
          <div className="min-w-0">
            <div className="text-[9.5px] uppercase tracking-[0.22em] text-[#927A5B]">Brand Studio</div>
            <div className="truncate text-[16px] text-[#2A1D14]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{title}</div>
          </div>
        </div>
        <PlatformProfileMenu user={user} onLogout={async () => { await logout(); nav("/"); }} />
      </div>
    </header>
    <main className="mx-auto w-full max-w-[1360px] min-w-0 overflow-x-clip px-4 py-5 md:px-8 md:py-6">
      {children}
    </main>
  </div>;
}
